import React from "react";
import PageTitle from "../components/PageTitle";
import ScheduleSection from "../Schedule";
import PageCarousel from "./PageCarousels";

const Pawnbroking = () => {
  PageTitle(
    "Pawnbroking - Right Cash - We Buy, We Sell, Buybacks, Pawnbrokers. Get Cash Fast - Chatham, Kent - Pawn Shop"
  );
  return (
    <div>
      <div class="page-header">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2>PAWNBROKING</h2>
            </div>
            <div class="col-12">
              <a href="">Home</a>
              <a href="">Pawnbroking</a>
            </div>
          </div>
        </div>
      </div>
      <PageCarousel collectionName="pawnbroking_banner" />

      <div class="about wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-5 col-md-6">
              <div class="about-img">
                <img src="img/pawnbroking1.png" alt="Image" />
              </div>
            </div>
            <div class="col-lg-7 col-md-6">
              <div class="section-header text-left">
                <h2>PAWNBROKING</h2>
              </div>
              <div class="about-text">
                <h3>
                  <p>
                    Our pawnbroking service gives you a way to raise instant
                    cash without needing to go through a lengthy loan
                    application – and better still, there’s no credit checks!
                  </p>
                </h3>
                <h3>
                  {" "}
                  <p>Here’s how it works:</p>
                </h3>
                <ul>
                  <li>
                    You bring in your item(s) of jewellery for a free valuation.
                  </li>
                  <li>
                    Leave the item of value with us as security and agree your
                    loan amount
                  </li>
                  <li>Sign your loan agreement</li>
                  <li>Receive your INSTANT cash within minutes</li>
                  <li>
                    Repay anytime you want during the loan period and collect
                    your goods
                  </li>
                </ul>
                <p>
                  We’ll consider most things in a good condition TV’s, games,
                  consoles, mobiles, laptops, jewellery, cameras, hi-fi’s, power
                  tools, musical instruments and anything else of value.
                </p>
                <a
                  class="btn"
                  href="https://api.whatsapp.com/send?phone=447871092759"
                >
                  FIND OUT MORE
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="about wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
              <div class="section-header text-left">
                <h2>Only 6% per month</h2>
                <p class="p-updated">
                  For example, if you borrow £100 for 7 Months at 6.0% monthly
                  interest you will repay just £142.00.
                </p>
              </div>
              <div class="about-text">
                <h3>
                  {" "}
                  <p>
                    Total Charge for credit: £42.00 (Interest only). Interest
                    rate 72.0% pa (Fixed) Representative 84.2% APR.
                  </p>
                  <p>
                    *If you are unable or choose not to repay the loan, your
                    item(s) will be sold to repay any amount outstanding. Monies
                    will be repaid to you if the sale proceeds are greater than
                    the amount under the loan. Late repayment can cause serious
                    money problems. For help and advice, visit
                    www.moneyadviceservice.org.uk
                  </p>
                </h3>
              </div>
            </div>
            <div class="col-lg-5 col-md-6">
              <div class="about-img">
                <img src="img/pawnbroking2.png" alt="Image" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
          <div class="row align-items-center">
            <div class="jewelry-list">
              <h2>For Pawnbroking we accept:</h2>
              <ul>
                <li>Diamond & Gem-set Jewellery</li>
                <li>Modern & Antique Gold Jewellery</li>
                <li>Rings, Bracelets & Chains</li>
                <li>Pendants, Earrings & Sovereigns</li>
                <li>Scrap and Broken Gold</li>
              </ul>
              <p>For anything else, please contact us.</p>
            </div>
            <div class="col-lg-5 col-md-6">
              <div class="about-img">
                <img src="img/didyoupawn.png" alt="Image" />
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div class="about-img">
                <img src="img/BOTTOM2-copy.png" alt="Image" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <ScheduleSection />
    </div>
  );
};

export default Pawnbroking;
